import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaCalendarAlt, FaChevronRight } from "react-icons/fa";
import { fetchBlogsPage } from "../api/blogsPage";
import { useHomePage } from "../context/HomePageContext";

const BlogsPage = () => {
  const { setContact } = useHomePage();
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const loadBlogsPage = async () => {
      try {
        const data = await fetchBlogsPage();
        if (!isMounted) return;

        setBlogs(data.blogs);
        if (data.contact) {
          setContact(data.contact);
        }
      } catch (err) {
        console.error(err);
      }
    };

    loadBlogsPage();

    return () => {
      isMounted = false;
    };
  }, [setContact]);

  if (blogs.length === 0) return null;

  return (
    <section className="bg-white pb-16 pt-10 md:pb-20 md:pt-12 lg:pb-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-7 lg:grid-cols-3 lg:gap-8">
          {blogs.map((blog) => (
            <article
              key={blog.id}
              className="overflow-hidden rounded-[16px] border border-[#E6E6E6] bg-white p-4 shadow-[0_4px_20px_rgba(0,0,0,0.04)]"
            >
              <div className="overflow-hidden rounded-[10px] bg-[#F7F7F7]">
                <img
                  src={blog.image}
                  alt={blog.title}
                  referrerPolicy="no-referrer"
                  className="aspect-[16/10] h-auto w-full object-cover"
                />
              </div>

              <div className="px-1 pb-2 pt-5">
                <div className="flex items-center gap-2 text-brand-orange">
                  <FaCalendarAlt className="text-[14px]" aria-hidden="true" />
                  <time className="text-[14px] font-medium">{blog.date}</time>
                </div>

                <h3 className="mt-3 text-[17px] font-bold leading-snug text-brand-purple md:text-[18px]">
                  {blog.title}
                </h3>

                <Link
                  to={blog.to}
                  className="mt-5 inline-flex items-stretch overflow-hidden rounded-[6px] border-2 border-brand-purple"
                >
                  <span className="flex items-center px-4 py-2 text-[14px] font-medium text-brand-purple">
                    Read More
                  </span>
                  <span className="m-1 flex items-center rounded-md bg-brand-purple px-2 py-2 text-white">
                    <FaChevronRight className="text-[12px]" aria-hidden="true" />
                  </span>
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogsPage;
